//auto scroll
const annElm = document.querySelector('.announcement__bar__new__wrapper .splide');

if(annElm){
    const announmentSplide = new Splide( annElm, {
    type   : 'loop',
    drag   : 'free',
    focus  : 'center',
    arrows : false,
    pagination : false,
    autoWidth : true,
    gap : '4rem',
    autoScroll: {
      speed: .5,
    },
     breakpoints: {
        1199: { gap : '2.4rem' }
      }
  });

  announmentSplide.mount( window.splide.Extensions );

}



setTimeout(() => {
  document.querySelector('.video__banner__wrapper')?.classList.remove('onload_height');
}, 100);

if (window.innerWidth <= 575) {
  setTimeout(() => {
    document.querySelector('.video__banner__wrapper')?.classList.remove('mobile_onload_height');
  }, 100);
}

if (!customElements.get('video-slider')) {
  class VideoSlider extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
      this.splideInstance = null;
      // Get the setting from the attribute
      this.perPageSetting = parseInt(this.getAttribute('data-per-page')) || 4;
    }

    connectedCallback() {
      this.initSplide();
      
      const slides = this.querySelectorAll(".splide__slide");
      this.setupVideoLogic(slides);
      this.initIntersectionObserver(slides);
    }

    initSplide() {
      const sliderElement = this.querySelector('.splide');
      if (!sliderElement) return;

      this.splideInstance = new Splide(sliderElement, {
        type: 'loop',
        perPage: this.perPageSetting,
        perMove: 1,
        gap: '12px',
        arrows: true,
        pagination: false,
        breakpoints: {
          1024: { perPage: Math.min(this.perPageSetting, 3) },
          768: { perPage: 2 },
          600: { perPage: 1 }
        }
      });

      this.splideInstance.mount();
    }

    setupVideoLogic(slides) {
      slides.forEach((item) => {
        const bagItem = item.querySelector(".bag_video_item");

        item.addEventListener("click", () => {
          // Prevent re-loading if video already exists
          if (bagItem.querySelector("video")) return;

          const tpl = item.querySelector("template");
          if (!tpl) return;

          const wrapper = tpl.content.firstElementChild.cloneNode(true);
          const video = wrapper.querySelector("video");

          bagItem.innerHTML = "";
          bagItem.appendChild(wrapper);

          video.play().catch((err) => console.warn("Autoplay blocked:", err));
        });
      });
    }

    initIntersectionObserver(slides) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Trigger the click logic to load videos when component is in view
              slides.forEach((slide) => slide.click());
            }
          });
        },
        { threshold: 0.3 }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.splideInstance) this.splideInstance.destroy();
    }
  }

  customElements.define("video-slider", VideoSlider);
}





// Toggle FAQ answers
document.addEventListener('DOMContentLoaded', () => {
  const faqs = document.querySelectorAll('.faq');
  const loadMoreBtn = document.querySelector('.faq-load-more');

  // Accordion
  faqs.forEach(item => {
    const question = item.querySelector('.question');
    const answer = item.querySelector('.answer');

    question.addEventListener('click', () => {
      const isActive = item.classList.contains('active');

      // Close all FAQs
      faqs.forEach(el => {
        el.classList.remove('active');
        el.querySelector('.answer').style.maxHeight = null;
      });

      // Open the clicked FAQ
      if (!isActive) {
        item.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  // Open first FAQ by default
  if (faqs.length > 0) {
    const firstFaq = faqs[0];
    const firstAnswer = firstFaq.querySelector('.answer');

    firstFaq.classList.add('active');
    firstAnswer.style.maxHeight = firstAnswer.scrollHeight + 'px';
  }

  // Load More
  if (loadMoreBtn) {
    const hiddenFaqs = document.querySelectorAll('.faq.hidden');

    // Hide the button if there are no hidden FAQs
    if (!hiddenFaqs.length) {
      loadMoreBtn.style.display = 'none';
      return;
    }

    loadMoreBtn.addEventListener('click', () => {
      hiddenFaqs.forEach(faq => {
        faq.classList.remove('hidden');
      });

      loadMoreBtn.style.display = 'none';
    });
  }
});


class PopuplarPosts extends HTMLElement {
  constructor() {
    super();
    this.input = null;
    this.posts = [];
    this.spinner = null;
    this.noResultEl = null;
  }

  connectedCallback() {
    this.input = this.querySelector('#blog_input');
    this.spinner = this.querySelector('.loading__spinner');
    const postList = this.querySelector('.main-posts');

    // collect posts
    this.posts = Array.from(postList.querySelectorAll('li.post'));

    // clone no results template
    const template = this.querySelector('#no-results-template');
    if (template) {
      this.noResultEl = template.content.firstElementChild.cloneNode(true);
      this.noResultEl.classList.add('hidden');
      postList.appendChild(this.noResultEl);
    }

    // debounce input handling
    const debouncedHandleInput = debounce(this.handleInput.bind(this), 300);
    this.input?.addEventListener('input', debouncedHandleInput);
  }

  handleInput(e) {
    const query = e.target.value.toLowerCase().trim();

    // If empty input → reset posts immediately
    if (query === '') {
      this.spinner?.classList.add('hidden');
      this.posts.forEach(post => post.classList.remove('hidden'));
      this.noResultEl?.classList.add('hidden');
      return;
    }

    // Show spinner
    this.spinner?.classList.remove('hidden');

    // Delay filtering until spinner "finishes"
    setTimeout(() => {
      this.spinner?.classList.add('hidden');

      let matchCount = 0;
      this.posts.forEach(post => {
        const title = post.querySelector('p')?.innerText.toLowerCase() || '';
        if (title.includes(query)) {
          post.classList.remove('hidden');
          matchCount++;
        } else {
          post.classList.add('hidden');
        }
      });

      // Show/hide "no results"
      if (this.noResultEl) {
        if (matchCount === 0) {
          this.noResultEl.classList.remove('hidden');
        } else {
          this.noResultEl.classList.add('hidden');
        }
      }
    }, 400); // match spinner timing
  }
}

customElements.define('popular-posts', PopuplarPosts);



/* Collection Buttons slide */
// document.querySelectorAll('.collection-btn-slide').forEach(function (el) {
//   var splide = new Splide(el, {
//     type: 'slide',
//     autoWidth: true,
//     perMove: 1,
//     gap: '10px',
//     arrows: false,
//     pagination: false,
//     breakpoints: {
//       768: {
//         gap: '10px',
//         arrows: true,
//       },
//       640: {
//         gap: '10px',
//       },
//     },
//   });
//   splide.mount();
// });


if (!customElements.get('collection-button')) {
  customElements.define('collection-button', class extends HTMLElement {
    connectedCallback() {
      if (typeof Splide === 'undefined') return;

      const el = this.querySelector('.collection-btn-slide');
      if (!el) return;

      // prevent double init
      if (el.classList.contains('is-initialized')) return;
      el.classList.add('is-initialized');

      this.splide = new Splide(el, {
        type: 'slide',
        autoWidth: true,
        perMove: 1,
        gap: '10px',
        arrows: false,
        pagination: false,
        breakpoints: {
          768: {
            gap: '10px',
            arrows: true,
          },
          640: {
            gap: '10px',
          },
        },
      }).mount();
    }

    disconnectedCallback() {
      this.splide?.destroy();
    }
  });
}


if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        button: '.tab-button',
        panel: '.tab-content-inner',
        slider: '.collection-slider-instance'
      };
      this.sliders = [];
      this.perPageSetting = parseInt(this.getAttribute('data-per-page')) || 4;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const sliderNodes = this.querySelectorAll(this.selectors.slider);
      const buttons = this.querySelectorAll(this.selectors.button);
      const panels = this.querySelectorAll(this.selectors.panel);

      // 1. Initialize Sliders
      sliderNodes.forEach((node, index) => {
        const splideInstance = new Splide(node, {
        type: 'loop',
        autoWidth: false, // important
        perPage: this.perPageSetting,
        perMove: 1,
        gap: 0,
        arrows: true,
        pagination: false,
        updateOnMove: true, // helps recalc widths
        breakpoints: {
          1024: { perPage: 3 },
          768: { perPage: 2 },
          600: { perPage: 1 }
        }
      });
        splideInstance.mount();
        this.sliders[index] = splideInstance;
      });

      // 2. Tab Logic
      buttons.forEach((btn, idx) => {
        btn.addEventListener('click', () => {
          // Toggle Classes
          buttons.forEach(b => b.classList.remove('active'));
          panels.forEach(p => p.classList.remove('active'));

          btn.classList.add('active');
          if (panels[idx]) {
            panels[idx].classList.add('active');
            
            // Refresh Splide to fix layout calculation on hidden tabs
            if (this.sliders[idx]) {
              this.sliders[idx].refresh();
            }
          }
        });
      });
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}







if (!customElements.get('testimonial-slider')) {
  class TestimonialSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector('.splide');
      this.instance = null;
    }

    connectedCallback() {
      if (this.sliderElement) {
        this.initSplide();
      }
    }

    initSplide() {
      const options = {
        type: 'slide',       // data-loop="false"
        perPage: 3,          // data-perpage-desktop="3"
        gap: '1.2rem',         // data-gap-desktop="2rem"
        arrows: true,        // data-arrows="true"
        pagination: false,   // data-pagination="false"
        
        breakpoints: {
          1024: {
            perPage: 2,      // data-perpage-tablet="2"
            gap: '1.2rem',     // data-gap-tablet="1rem"
          },
          768: {
            perPage: 1,      // data-perpage-mobile="1"
            gap: '0.5rem',   // data-gap-mobile="0.5rem"
          }
        }
      };

      this.instance = new Splide(this.sliderElement, options);
      this.instance.mount();
    }

    disconnectedCallback() {
      if (this.instance) {
        this.instance.destroy();
      }
    }
  }

  customElements.define('testimonial-slider', TestimonialSlider);
}



if (!customElements.get('blog-slider')) {
  class BlogSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderNode = this.querySelector('.blog-slider-instance');
      this.instance = null;
    }

    connectedCallback() {
      if (this.sliderNode) this.init();
    }

    init() {
      this.instance = new Splide(this.sliderNode, {
        type: 'loop',
        perPage: 2,         // Shows 2 cards on desktop next to sidebar
        perMove: 1,
        padding: { left: '0', right: '10%' },
        gap: '12px',
        arrows: true,
        pagination: false,
        breakpoints: {
          1200: { perPage: 2 },
          990: { perPage: 1.5, gap: '12px' }, // Partial peek on tablets
          750: { perPage: 1, gap: '12px' }
        }
      });
      this.instance.mount();
    }

    disconnectedCallback() {
      if (this.instance) this.instance.destroy();
    }
  }
  customElements.define('blog-slider', BlogSlider);
}